module.exports = __webpack_public_path__ + "static/media/invitation-accepted.40196994.svg";